/**
* directives.validators Module
*
* Description
*/

var app = angular.module('directives.validators', []);
require('./validators.directives.js');

module.exports =  app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/validators/index.js
 ** module id = 241
 ** module chunks = 1
 **/